import React from 'react';

const BreadcrumbArrow = () => <span> › </span>;

export default BreadcrumbArrow;
